// ─── CHARACTER CREATION BUDGETS ─────────────────────────────────────────────
// These control how many points players get during character creation
// ─── BUDGET CONSTANTS ───────────────────────────────────────────────────────
export const STAT_POINTS_TO_ALLOCATE = 10;  // beyond race base
export const PERKS_FROM_RACE = 2;           // choose 2 of 3 race perks
export const FREE_PERKS = 1;                // 1 additional perk, any skill
export const SKILL_LEVELS_TO_ALLOCATE = 10; // total across all skills/magics
export const MAX_LEVELS_PER_SKILL = 3;      // at char creation/ Total skill levels to distribute

// ─── EXPERIENCE COSTS ───────────────────────────────────────────────────────
// These control how much EXP it costs to upgrade things during leveling

export const STAT_COST = 2;        // Cost per stat point upgrade
export const SKILL_COST = 3;       // Cost per skill level upgrade
export const MAGIC_COST = 4;       // Cost per magic school level
export const ALCHEMY_COST = 4;     // Cost per alchemy class upgrade
export const ABILITY_COST = 8;     // Cost for special abilities

// ─── GAMEPLAY LIMITS ────────────────────────────────────────────────────────
// Maximum values for various character attributes

export const MAX_STAT = 50;        // Maximum value for any stat
export const MAX_SKILL = 10;       // Maximum level for any skill
export const MAX_MAGIC = 10;       // Maximum level for any magic school
export const MAX_ALCHEMY = 5;      // Maximum alchemy class level

// ─── CALCULATED VALUES ──────────────────────────────────────────────────────
// Helper functions for common calculations

export function getStatModifier(statValue) {
  return Math.floor(statValue / 10);
}

export function getMagicPower(magicStat) {
  return Math.floor(magicStat / 5);
}
